<template>
	<div class="selectComponent">
		<select class="singleSelect" v-model="selectValue">
      <option value=''>请选择...</option>
      <option v-for="item in selectList" :key="item.value" :value="item.value" @change="handleChange">{{ item.name }}</option>
		</select>
	</div>
</template>

<script>
	export default{
		name: "SelectComponent",
		props: {
			value: {},
			selectList: Array,
		},
		methods:{
			handleChange(val){
				this.$emit('change',val)
			}
		},
		computed:{
			selectValue:{
        get() {
          return this.value
        },
        set(val) {
          this.$emit("input", val)
        }
			}
		}
	}
</script>

<style>
	.singleSelect{
		height: 30px;
		line-height: 30px;
		width: 100%;
		border-radius: 5px;
		padding: 0 10px;
	}
</style>
